module.exports = __webpack_public_path__ + "static/gallery1-62d0df8d2708bb9c20b2c8ece5c2c813.jpg";